import React from 'react';
import { Text, View, StyleSheet, type Styles } from '@react-pdf/renderer';

import { PDF_COLORS } from '../pdfColors';
import { pdfSafeText } from '../pdfSafeText';

const styles = StyleSheet.create({
  location: {
    fontSize: 5.5,
    fontFamily: 'Poppins',
    color: PDF_COLORS.greyDark,
    textAlign: 'center',
    marginTop: 1,
  },
});

/**
 * Pie de una foto en el informe: el nombre y, debajo, dónde se hizo (spec
 * fotos geolocalizadas § 19). Un PDF no conserva el EXIF de sus imágenes, así
 * que la ubicación tiene que ir ESCRITA. Sin ubicación, solo el nombre, como
 * siempre.
 *
 * Los textos pasan por `pdfSafeText`: un carácter que Poppins no tenga saldría
 * como una comilla sin avisar («·» y «±» sí están, medido con fontkit).
 */
export const PhotoCaption = ({
  name,
  location,
  nameStyle,
}: {
  name: string;
  location?: string[];
  nameStyle: Styles[string];
}) => (
  <View>
    <Text style={nameStyle}>{name}</Text>
    {location?.map((line, i) => (
      <Text key={i} style={styles.location}>
        {pdfSafeText(line)}
      </Text>
    ))}
  </View>
);

export default PhotoCaption;
